/* Table.ts */

export enum TableType {
  RESPONSE_TABLE = "responseTable",
  TREATMENT_TABLE = "treatmentTable",
}
